import { Table } from "types/Table";

export const JAZZBAR_TABLES: Table[] = [
  {
    capacity: 3,
    title: "Table 1",
    reference: "jazzbar-table-1",
    rows: 2,
    columns: 2,
  },
  {
    capacity: 3,
    title: "Table 2",
    reference: "jazzbar-table-2",
    rows: 2,
    columns: 2,
  },
  {
    capacity: 3,
    title: "Table 3",
    reference: "jazzbar-table-3",
    rows: 2,
    columns: 2,
  },
  {
    capacity: 5,
    title: "Table 4",
    reference: "jazzbar-table-4",
    rows: 3,
    columns: 2,
  },
  {
    capacity: 5,
    title: "Table 5",
    reference: "jazzbar-table-5",
    rows: 3,
    columns: 2,
  },
  {
    capacity: 5,
    title: "Table 6",
    reference: "jazzbar-table-6",
    rows: 2,
    columns: 3,
  },
  {
    capacity: 5,
    title: "Table 7",
    reference: "jazzbar-table-7",
    rows: 2,
    columns: 3,
  },
  {
    capacity: 5,
    title: "Table 8",
    reference: "jazzbar-table-8",
    rows: 2,
    columns: 3,
  },
  {
    capacity: 5,
    title: "Table 9",
    reference: "jazzbar-table-9",
    rows: 2,
    columns: 3,
  },
  {
    capacity: 7,
    title: "The Band",
    reference: "jazzbar-table-band",
    rows: 2,
    columns: 4,
  },
  {
    capacity: 3,
    title: "Table 10",
    reference: "jazzbar-table-10",
    rows: 3,
    columns: 1,
  },
  {
    capacity: 5,
    title: "Table 11",
    reference: "jazzbar-table-11",
    rows: 3,
    columns: 2,
  },
  {
    capacity: 5,
    title: "Table 12",
    reference: "jazzbar-table-12",
    rows: 2,
    columns: 3,
  },
];
